module.exports = __webpack_public_path__ + "img/nami_twilight.e246c58a.png";